export function noop<T = void>(...args: any[]): T {
    return null as T
}
